export const getters = {
  getIsSending: ($state) => $state.uiFlags.isSending,
};
